/* BVONA — Charm swatch swap */
(function(){

  var CHARM_IMAGES = {
    'Serpente': 'https://cdn.shopify.com/s/files/1/0590/4777/2325/products/charmsnakeoff.jpg',
    'Serpente Argento': 'https://cdn.shopify.com/s/files/1/0590/4777/2325/files/Charm_snake_silver_off.jpg',
    'Croce': 'https://cdn.shopify.com/s/files/1/0590/4777/2325/products/Charmcrossoff.jpg',
    'Mano Cornuta': 'https://cdn.shopify.com/s/files/1/0590/4777/2325/products/Charmmanooff.jpg',
    'Sacro Cuore': 'https://cdn.shopify.com/s/files/1/0590/4777/2325/products/Charmheartoff.jpg',
    'Tredici': 'https://cdn.shopify.com/s/files/1/0590/4777/2325/products/13-off.jpg',
    'Vaffanculo': 'https://cdn.shopify.com/s/files/1/0590/4777/2325/products/Charmvafangoff.jpg',
    'In Bocca al Lupo': 'https://cdn.shopify.com/s/files/1/0590/4777/2325/products/lupooffblueoff.jpg'
  };

  function swapSwatches() {
    var fieldsets = document.querySelectorAll('.variant-picker__option');
    var charmFieldset = null;
    fieldsets.forEach(function(f) {
      var legend = f.querySelector('legend');
      if(legend && legend.textContent.trim() === 'Charm') charmFieldset = f;
    });
    if(!charmFieldset) return;
    var thumbs = charmFieldset.querySelectorAll('.option-value--thumbnail');
    thumbs.forEach(function(thumb) {
      var label = thumb.querySelector('.option-value__label');
      if(!label) return;
      var charmName = label.textContent.trim();
      var charmImg = CHARM_IMAGES[charmName];
      if(!charmImg) return;
      var img = thumb.querySelector('img');
      if(img) { img.src = charmImg; img.srcset = charmImg; }
    });
  }

  if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', swapSwatches);
  } else {
    swapSwatches();
  }
  document.addEventListener('variant:changed', function() { setTimeout(swapSwatches, 50); });
  setInterval(swapSwatches, 500);

  /* The cart free-bag prompt used to be injected from here, on a one-second
     interval, with no entitlement logic — so it kept offering a complimentary
     bag after one had already been chosen. It is now rendered server-side by
     sections/cart-drawer.liquid from snippets/bvona-gift-entitlement.liquid,
     the same calculation the cart page uses. No timer, never stale. */

})();
